var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.93652V12.249C11.25 12.7132 11.0656 13.1583 10.7374 13.4865C10.4092 13.8146 9.96413 13.999 9.5 13.999H2.5C2.03587 13.999 1.59075 13.8146 1.26256 13.4865C0.934374 13.1583 0.75 12.7132 0.75 12.249V1.74902C0.75 1.28489 0.934374 0.839775 1.26256 0.511587C1.59075 0.183398 2.03587 -0.000976562 2.5 -0.000976562H7.3125L11.25 3.93652ZM8.625 3.93652C8.2769 3.93652 7.94306 3.79824 7.69692 3.5521C7.45078 3.30596 7.3125 2.97212 7.3125 2.62402V0.874023H2.5C2.26794 0.874023 2.04538 0.966211 1.88128 1.1303C1.71719 1.2944 1.625 1.51696 1.625 1.74902V12.249C1.625 12.4811 1.71719 12.7036 1.88128 12.8677C2.04538 13.0318 2.26794 13.124 2.5 13.124H9.5C9.73206 13.124 9.95462 13.0318 10.1187 12.8677C10.2828 12.7036 10.375 12.4811 10.375 12.249V3.93652H8.625Z",
    fill: "#356966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.afc9238940061932348f119be8a66009.svg";
export { ForwardRef as ReactComponent };